import { styled as o } from "styled-components";
import { Icon as t } from "../Icon/index.js";
import { MediaQuery as e } from "../../styles/variables.js";
import { CaptionHeavy as n } from "../../styles/typography/index.js";
import { Theme as r } from "../../styles/themes/index.js";
const s = o.button`
  color: rgb(${r.colors.Alpha});
  text-align: center;
  border: 0;
  margin: 0 16px;
  background: transparent;
  justify-content: center;
  display: flex;
  align-items: center;
  min-height: 48px;
  width: 100%;
  cursor: pointer;
  ${n};

  &:disabled {
    cursor: default;
  }

  @media ${e.SCREEN_MD_UP} {
    margin: 0;
    font-size: 16px;
    line-height: 20px;
  }
`, d = o.span`
  margin: -2px 4px 0 0;
`, l = o(t)`
  color: rgb(${r.colors.Brand});
`;
export {
  l as LoadMoreButtonArrow,
  s as LoadMoreButtonContainer,
  d as LoadMoreButtonText
};
